import React, { Component } from 'react';
import PropTypes from 'prop-types';

export const withEditable = (WrappedComp) => {
  return class EditableLabel extends Component {
    constructor(props) {
      super(props);
      const { valueKey } = props;
      this.handleChange = this.handleChange.bind(this);
      this.onBlur = this.onBlur.bind(this);
      this.state = {
        isDirty: false,
        value: props[valueKey] || '',
      };
    }

    handleChange(e) {
      const {
        valueKey
      } = this.props;
      this.setState({
        value: e.target.value,
        isDirty: (this.props[valueKey] !== e.target.value)
      });
    }

    onBlur() {
      const {
        onEdit = () => {},
        onBlur = () => {}
      } = this.props;
      if (this.state.isDirty) {
        onEdit(this.state.value);
      }
      this.setState({
        isDirty: false
      });
      onBlur();
    }

    render() {
      const {
        valueKey,
        isEditing = false
      } = this.props;

      const newProps = {
        [valueKey]: this.state.value
      };

      return (
        <div>
          {isEditing &&
            <input
              autoFocus
              onChange={this.handleChange}
              onBlur={this.onBlur}
              value={this.state.value}
              className='w-100'
            />}
          {!isEditing &&
            <WrappedComp {...this.props} {...newProps}/>
          }
        </div>
      );
    }
  };
  EditableLabel.propTypes = {
    valueKey: PropTypes.string.isRequired,
    onEdit: PropTypes.func.isRequired
  };
};



// WEBPACK FOOTER //
// ./src/Common/EditableLabel.js